import { createContext } from 'react';

const AuthContextVar = createContext();

export const AuthContext = AuthContextVar;
